import { render, staticRenderFns } from "./OrganisationDashboard.vue?vue&type=template&id=c6d53236&"
import script from "./OrganisationDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d53236')) {
      api.createRecord('c6d53236', component.options)
    } else {
      api.reload('c6d53236', component.options)
    }
    module.hot.accept("./OrganisationDashboard.vue?vue&type=template&id=c6d53236&", function () {
      api.rerender('c6d53236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/organisationDashboard/OrganisationDashboard.vue"
export default component.exports